import angular from 'angular';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('InvoicingViaRelationsDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    '$element',
    'close',
    '$q',
    '$timeout',
    'relationId',
    invoicingViaRelationsDialogCtrl,
  ]);

function invoicingViaRelationsDialogCtrl(
  $http,
  appUrls,
  flySvc,
  $element,
  close,
  $q,
  $timeout,
  relationId,
) {
  var vm = this;
  vm.modalLoaded = false;
  vm.cancel = function() {
    close(null, 500);
  };

  vm.getInvoicedRelations = function(params) {
    return $http
      .get(appUrls.api + '/api/relation/invoicingvia/invoicedRelations', {
        params: {
          id: relationId,
          ...params,
        },
      })
      .then(
        ({ data }) => {
          return data;
        },
        error => {
          flySvc.error(error);
          return '';
        },
      );
  };

  // the infinite scroll table directive doesn't work if the modal controller is still not fully initialized (the retrieve func is not yet set)
  // to fix this we only load the scrollable table when we retrieve func is definitely set (at the end of the controller)
  vm.modalLoaded = true;
}
